import {MAX_TEXTURE_UNITS} from "#webgl2/constants"

export const ATLAS_TEXTURE_UNIT_OFFSET = MAX_TEXTURE_UNITS

export const VERTEX_FLAG_INDEX_MASK = 0b11
export const VERTEX_FLAG_IS_BOUNDARY = 1 << 8

export const LOC_POSITION = 0
export const LOC_UV = 1
export const LOC_COLOR = 2
export const LOC_FLAGS = 3
export const LOC_POSITION_PREV = 4
export const LOC_POSITION_NEXT = 5
export const LOC_UV_GRAD = 6
